import React, { Component } from 'react';
import Select from 'react-select';
import { getCustomSelectStyles } from '_utils';

import { Translate, translateKey } from '_translations';

class Filters extends Component {
  render() {
    if (this.props.events.contentLoading === true) {
      return null;
    }

    return (
      <div className="gallery-search-container">
        <div className="gallery-search">
          <span className="icon icon--search" onClick={this.props.handleSearch}></span>
          <input type="Text" placeholder={translateKey('Thunderbolt.SearchPlaceholder')} value={this.props.searchTerm} onChange={this.props.handleSearchChange} />
        </div>
        <div className="gallery-event-search">
          <Select
            options={this.getEventsGroupedByCountry()}
            styles={getCustomSelectStyles()}
            isClearable={true}
            placeholder={<div className="event-placeholder"><span><Translate resourceString="Thunderbolt.FilterBy"/> </span><b><Translate resourceString="Thunderbolt.Event"/></b></div>}
            onChange={this.props.handleEventSelected}
            value={this.props.selectedEvent}>
          </Select>
        </div>
      </div>
    );
  }

  getEventsGroupedByCountry = () => {
    const groupedEvents = [];

    for (let index = 0; index < this.props.events.content.eventLocations.length; index++) {
      const eventLocation = this.props.events.content.eventLocations[index];

      const existing = groupedEvents.find(x => x.label === eventLocation.countryName);
      if (existing !== undefined) {
        existing.options.push({
          label: eventLocation.eventName,
          value: eventLocation.eventName,
          customData: { latitude: eventLocation.latitude, longitude: eventLocation.longitude },
        });
      } else {
        groupedEvents.push({
          label: eventLocation.countryName,
          options: [
            {
              label: eventLocation.eventName,
              value: eventLocation.eventName,
              customData: { latitude: eventLocation.latitude, longitude: eventLocation.longitude },
            },
          ],
        });
      }
    }

    // Order Countries
    groupedEvents.sort((a, b) => this.sortAlphabetically(a, b));

    // Order Events
    for (let index = 0; index < groupedEvents.length; index++) {
      groupedEvents[index].options.sort((a, b) => this.sortAlphabetically(a, b));
    }

    return groupedEvents;
  }

  sortAlphabetically(a, b) {
    if (a.label < b.label) {
      return -1;
    }

    if (a.label > b.label) {
      return 1;
    }

    return 0;
  }
}

export default Filters;
